<h2 mat-dialog-title>
    Batch Rollover Contracts
    <button mat-icon-button class="refresh-button" [disabled]="loading" (click)="loadRolloverData()"
        matTooltip="Refresh data">
        <mat-icon>refresh</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading rollover data...</p>
    </div>

    <div *ngIf="!loading">
        <p>You are about to rollover {{rolloverData.length}} contracts with a total of {{getTotalItems()}} hire items.
            Review their prices below before continuing</p>

        <div *ngFor="let docket of rolloverData" class="docket-container">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Contract #{{docket.id}}
                        <a mat-icon-button color="primary" href="/docket/{{docket.id}}" target="_blank">
                            <mat-icon>open_in_new</mat-icon>
                        </a>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="flex flex-row justify-between items-center w-full">
                            <p>
                                {{docket.customer_full_name}} - Total hires: {{docket.total_charge | hlCurrency:
                                docket.currency_code:
                                docket.conversion_rate:false | async}}
                            </p>
                            @switch (docket.icon) {
                            @case ('error') {
                            <mat-icon [matTooltip]="docket.message" class="text-red-500">error</mat-icon>
                            }
                            @case ('warning') {
                            <mat-icon [matTooltip]="docket.message" class="text-yellow-500">warning</mat-icon>
                            }
                            @case ('success') {
                            <mat-icon [matTooltip]="docket.message" class="text-green-500">check_circle</mat-icon>
                            }
                            @default {
                            <mat-icon>info</mat-icon>
                            }
                            }
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <table mat-table [dataSource]="docket.items" class="mat-elevation-z1 full-width">
                    <!-- Item Code Column -->
                    <ng-container matColumnDef="item_code">
                        <th mat-header-cell *matHeaderCellDef>Hired</th>
                        <td mat-cell *matCellDef="let item">{{item.product_name}} ({{item.item_code}})</td>
                    </ng-container>

                    <!-- On Hire Column -->
                    <ng-container matColumnDef="on_hire">
                        <th mat-header-cell *matHeaderCellDef>On Hire</th>
                        <td mat-cell *matCellDef="let item" [matTooltip]="item.on_hire | amDateFormat:dateFormat">
                            {{item.on_hire | amTimeAgo}}
                        </td>
                    </ng-container>

                    <!-- Off Hire Column -->
                    <ng-container matColumnDef="off_hire">
                        <th mat-header-cell *matHeaderCellDef>Off Hire</th>
                        <td mat-cell *matCellDef="let item" [matTooltip]="item.off_hire | amDateFormat:dateFormat">
                            @if(item.off_hire) {
                            {{item.off_hire | amTimeAgo}}
                            } @else {
                            -
                            }
                        </td>
                    </ng-container>

                    <!-- Charge Column -->
                    <ng-container matColumnDef="charge">
                        <th mat-header-cell *matHeaderCellDef>Charge</th>
                        <td mat-cell *matCellDef="let item">
                            <app-charge-display [item]="item" [currencyCode]="docket.currency_code"
                                [conversionRate]="docket.conversion_rate">
                            </app-charge-display>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </mat-expansion-panel>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="loading" (click)="onConfirm()">
        Confirm Rollover
    </button>
</mat-dialog-actions>